import gql from 'graphql-tag'

export const FRAGMENT_PRODUCT_BASE = gql`
  fragment product on Product {
    id
    title
    isAdultOnly
    urlKey
    mainCategoryUrlKey
    mainMenuUrlKey
    mainVariant {
      id
      price
      title
      gift
      hasSale
      labels
      mediaIds
      variantUrl
      isAvailable
      availability {
        countMall
      }
    }
  }
`

export const FRAGMENT_PRODUCT_BASE_WITH_COUPON = gql`
  fragment productBaseWithCoupon on Product {
    id
    title
    isAdultOnly
    urlKey
    mainCategoryUrlKey
    mainMenuUrlKey
    productTypeId
    mainVariant {
      id
      price
      defaultActualPrice
      title
      gift
      hasSale
      labels
      mediaIds
      variantUrl
      isAvailable
      availability {
        countMall
        isAvailable
      }
      freeDelivery
      discountPrice
      discountPromotionPrice
      discountPromotionSalePrice
      priceRrp
      inPromotion
      rrpSavePercent
      coupon {
        code
        description
        expirationDate
        id
        nominalValue {
          currency
          value
        }
        percentualValue
      }
      pricingGroups {
        id
        price
      }
    }
  }
`
